import React from "react";
import { useTranslation } from "react-i18next";
import { TransformedProduct } from "../../../../product/types/productApiTypes";
import CardActions from "../../../../product/components/common/ProductCard/CardActions";
import Icon from "../../../../../../common/components/Icon/Icon";
import WishlistToggleButton from "../../../../wishlist/components/common/WishlistToggleButton";

interface CompareHeaderCellProps {
  product: TransformedProduct;
  onRemove: (id: number) => void;
  // Update Prop Type: Accept the full product object
  onQuickView: (product: TransformedProduct) => void;
}

const CompareHeaderCell: React.FC<CompareHeaderCellProps> = ({
  product,
  onRemove,
  onQuickView,
}) => {
  const { t } = useTranslation();
  const image = product.images[0] || null;

  // Logic: If it's a variation, we want to add the PARENT to the wishlist.
  // If it's a simple product, parentId is 0, so we use the product.id.
  const wishlistTargetId = product.parentId > 0 ? product.parentId : product.id;

  return (
    <div className="compare-header-card">
      <div className="compare-header-card__top-actions">
        <WishlistToggleButton
          productId={wishlistTargetId}
          className="compare-header-card__action-btn"
        />

        <button
          className="compare-header-card__action-btn compare-header-card__action-btn--remove"
          onClick={() => onRemove(product.id)}
          aria-label={t("comparePage.removeLabel", "Remove")}
        >
          <Icon iconName="x-mark" />
        </button>
      </div>

      <a href={product.permalink} className="compare-header-card__image">
        {image ? (
          <img src={image.thumbnail} alt={image.alt || product.name} />
        ) : (
          <div className="placeholder-image" />
        )}
      </a>

      <h3 className="compare-header-card__title">
        <a href={product.permalink}>{product.name}</a>
      </h3>

      <div className="compare-header-card__actions">
        <CardActions
          product={product}
          // Override the ID-only callback to pass the full product
          onQuickViewClick={() => onQuickView(product)}
        />
      </div>
    </div>
  );
};

export default CompareHeaderCell;
